import styled from 'styled-components';

const LoadingSpacer = styled.div`
  padding: 24px;
`;

LoadingSpacer.displayName = 'LoadingSpacer';

export default LoadingSpacer;
